import React, { useState } from 'react';
import { useMood } from '../../../contexts/MoodContext';

/**
 * GratitudeActivity — "Tiny Gratitude Sparkles".
 *
 * Entirely tap-based: no typing, no form. Tap any little things that feel good
 * right now and they sparkle; keep them privately if you like, or just enjoy the
 * moment and move on. Saving is optional and, when chosen, stores the taps as a
 * private note via the MoodContext — never required to continue.
 */
const SPARKS = [
  'A small win', 'My team', 'A good coffee', 'Fresh air', 'Someone kind', 'Progress today',
  'A good song', 'A moment of calm', 'Family', 'A laugh', 'Something I learned', 'Rest',
];

export const GratitudeActivity: React.FC = () => {
  const { addCheckIn, sessionMood } = useMood();
  const [picked, setPicked] = useState<string[]>([]);
  const [saved, setSaved] = useState(false);

  const toggle = (label: string) => {
    setSaved(false);
    setPicked((prev) => (prev.includes(label) ? prev.filter((x) => x !== label) : [...prev, label]));
  };

  const keep = () => {
    if (!picked.length || !sessionMood) return;
    addCheckIn({
      mood: sessionMood,
      journalEntry: `Grateful for:\n${picked.map((x) => `• ${x}`).join('\n')}`,
    });
    setPicked([]);
    setSaved(true);
  };

  return (
    <div className="mm-grat">
      <p className="mm-grat__lead">Tap a few things that feel good right now ✨</p>
      <div className="mm-grat__chips">
        {SPARKS.map((label) => {
          const on = picked.includes(label);
          return (
            <button
              key={label}
              type="button"
              className={`mm-grat__chip ${on ? 'is-on' : ''}`}
              aria-pressed={on}
              onClick={() => toggle(label)}
            >
              {label}
              {on && <span className="mm-grat__spark" aria-hidden="true">✨</span>}
            </button>
          );
        })}
      </div>
      <div className="mm-activity__controls">
        <button type="button" className="mm-btn mm-btn--primary" onClick={keep} disabled={!picked.length}>
          Keep these privately
        </button>
        {saved && <span className="mm-saved-note">Kept in your private space ✓</span>}
      </div>
      <p className="mm-grat__note">Just for you — tap to enjoy, keep only if you want to.</p>
    </div>
  );
};

export default GratitudeActivity;
